var map = {
	"./adjustment.svg": "b68b",
	"./arrow-back.svg": "27dc",
	"./basket.svg": "cb53",
	"./burger.svg": "87f4",
	"./check.svg": "f75a",
	"./close.svg": "7710",
	"./external-link.svg": "841c",
	"./fb-round.svg": "e2f0",
	"./fb.svg": "2203",
	"./heart-empty.svg": "e710",
	"./heart.svg": "c40a",
	"./inst.svg": "8fb3",
	"./load-more.svg": "6fe8",
	"./message.svg": "47ff",
	"./print.svg": "04d5",
	"./product1.svg": "adf5",
	"./product2.svg": "ef22",
	"./product3.svg": "9914",
	"./product4.svg": "6945",
	"./product5.svg": "c4cc",
	"./search.svg": "8e8d",
	"./select-arrow.svg": "2acf",
	"./sort.svg": "e528",
	"./trashcan.svg": "9295"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";